export const categories = [
  { slug: "all", name: "全部平台", count: 8 },
  { slug: "zonghe", name: "综合平台", count: 2 },
  { slug: "dianying", name: "电影专区", count: 1 },
  { slug: "dianshiju", name: "电视剧集", count: 2 },
  { slug: "dongman", name: "动漫专区", count: 2 },
  { slug: "duanshipin", name: "短视频", count: 1 },
];

export const categoryMap: Record<string, string> = {
  "all": "全部平台",
  "zonghe": "综合平台",
  "dianying": "电影专区",
  "dianshiju": "电视剧集",
  "dongman": "动漫专区",
  "duanshipin": "短视频",
};